/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
// import 'vuetify/styles';
import '@/settings.scss'

// Composables
import { createVuetify } from 'vuetify'
import { aliases, md } from 'vuetify/iconsets/md'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VTimePicker, VDateInput } from 'vuetify/lib/labs/components.mjs'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    icons: {
        defaultSet: 'md',
        aliases,
        sets: {
            md
        }
    },
    components: {
        ...components,
        VTimePicker,
        VDateInput
    },
    directives,
    theme: {
        defaultTheme: 'dark',
        themes: {
            dark: {
                dark: true,
                colors: {
                    body: '#000000',
                    background: '#000000',
                    surface: '#000000',
                    primary: '#FFFFFF',
                }
            },
            light: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    primary: '#000000',
                }
            }
        }
    }
})
